module.exports = __webpack_public_path__ + "img/5f_r_torikoma@2x.71a49222.png";